export default angular
  .module('app.conf')
  .constant('HoldingConfig', {
    airbrake: {
      id: '303998',
      key: 'b604561e3e89c0015216bc2aaf416272',
    },
    recaptcha: {
      sitekey: '6Lcv0iUTAAAAAFaC-bVgyZ5hAmdSV8eFlveACAie',
    },
    settings: {
      errorReporting: {
        enabled: true,
      },
      maxPendingTransfers: 10,
    },
  })
  .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/conf/constants/config.js